import ReactGA from "react-ga"
import config from "./config"

function initializeReactGA() {
	if (config.ga && config.ga.id) {
		ReactGA.initialize(config.ga.id)
		ReactGA.pageview(window.location.pathname + window.location.search)
	}
}

function eventGetReactGA({ category, action }) {
	if (config.ga && config.ga.id) {
		ReactGA.event({
			category,
			action
		})
	}
}

export { initializeReactGA, eventGetReactGA }
